export default __webpack_public_path__ + "static/media/DarkLogo.61d026bb.svg";